import {initWebComponent} from "@/helpers/web-component-helper";
import {
    LayerMenuSwitcherButtonActiveComponent
} from "@/components/layer/menu/switcher/layer-menu-switcher-button-active-component";
import {LayerMenuSwitcherButtonComponent} from "@/components/layer/menu/switcher/layer-menu-switcher-button-component";
import {
    LayerMenuSwitcherButtonOverviewComponent
} from "@/components/layer/menu/switcher/layer-menu-switcher-button-overview-component";
import {LayerMenuButtonSession} from "@/components/layer/menu/button/layer-menu-button-session";
import {getToken} from "@/helpers/auth/auth-helper";

export class LayerMenuSwitcherComponent extends HTMLElement{
    constructor(){
        super();

        const template = document.createElement('template');

        let displayNone = 'd-none'
        if(getToken()) {
            displayNone = ''
        }

        template.innerHTML = `
    <div class="mt-2 mb-2 d-none">
        <div class="btn-group btn-group-toggle bg-light p-1 d-flex" data-toggle="buttons">
            <label class="btn btn-default btn-tools btn-sm md-btn-flat waves-effect active">
                <layer-menu-switcher-button-overview></layer-menu-switcher-button-overview>
            </label>
            <label class="btn btn-default btn-tools btn-sm md-btn-flat waves-effect">
                 <layer-menu-switcher-button-active></layer-menu-switcher-button-active>
            </label>
        </div>
    </div>
    <div class="row mt-2 mb-2 ml-0 mr-0">
        <div class="col-6 pl-0 pr-0">
          <layer-menu-add-dataset-item></layer-menu-add-dataset-item>
        </div>
        <div class="col-6 ${displayNone} pl-1 pr-0">
            <layer-menu-button-session></layer-menu-button-session>
        </div>
    </div>`

        initWebComponent(this, template)
    }
}

window.customElements.define("layer-menu-switcher-button-active", LayerMenuSwitcherButtonActiveComponent);
window.customElements.define("layer-menu-switcher-button-overview", LayerMenuSwitcherButtonOverviewComponent);
window.customElements.define("layer-menu-switcher-button", LayerMenuSwitcherButtonComponent);
window.customElements.define("layer-menu-button-session", LayerMenuButtonSession);
